"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var i18n_1 = require("../../i18n");
var MANDATORY_FIELDS_META = require("./../../assets/metadata/mandatoryFields.json");
var Payments = (function () {
    function Payments() {
        var _this = this;
        this.inited = false;
        this.initInProgress = false;
        this.state = { mandatoryFields: [] };
        this.props = {};
        this.subscribers = {};
        this.initPayments = function (_a) {
            var paymentsSDK = _a.paymentsSDK, paymentMethod = _a.paymentMethod, orderId = _a.orderId, locale = _a.locale;
            return new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.isInited(paymentMethod.connectedProviderId)) {
                                return [2 /*return*/, resolve()];
                            }
                            this.cashierPayments = paymentsSDK;
                            this.subscribers.mandatoryFields = this.subscribers.mandatoryFields || [];
                            this.props = {
                                locale: locale,
                                paymentMethod: paymentMethod,
                                orderId: orderId,
                            };
                            this.initInProgress = true;
                            return [4 /*yield*/, i18n_1.init({ locale: this.props.locale || 'en' })];
                        case 1:
                            _a.sent();
                            this.inited = true;
                            this.initInProgress = false;
                            resolve();
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        this.setPaymentMethod = function (_a) {
            var paymentMethod = _a.paymentMethod;
            _this.props.paymentMethod = paymentMethod;
            _this.state.mandatoryFields = [];
        };
        this.subscribe = function (name, listener) {
            _this.subscribers[name].push(listener);
        };
        this.reset = function () { return _this.destroy(); };
        this.destroy = function () {
            _this.inited = false;
            _this.props = {};
            _this.cashierPayments = null;
            _this.state = { mandatoryFields: [] };
            _this.subscribers = {};
            _this.initInProgress = false;
            return Promise.resolve({ status: 'OK' });
        };
        this.isInited = function (connectedProviderId) {
            var currentConnectedProviderId = _this.props.paymentMethod && _this.props.paymentMethod.connectedProviderId;
            return (_this.inited || _this.initInProgress) && connectedProviderId === currentConnectedProviderId;
        };
        this.renderPaymentMethod = function (name, node) { return _this.cashierPayments.render(name, node); };
        this.getMandatoryFields = function () { return _this.state.mandatoryFields; };
        this.fetchMandatoryFields = function () { return __awaiter(_this, void 0, void 0, function () {
            var orderId, paymentMethod, result, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        orderId = this.props.orderId;
                        paymentMethod = this.props.paymentMethod.connectedProviderId;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.cashierPayments.fetchMandatoryFields({ orderId: orderId, paymentMethod: paymentMethod })];
                    case 2:
                        result = _a.sent();
                        if (!result.mandatoryFields) {
                            // as server has bug with removing properties when array is empty, we need this fallback
                            result.mandatoryFields = [];
                        }
                        this.setData('mandatoryFields', this.sortMandatoryFields(this.decorateWithUIProps(result.mandatoryFields)));
                        return [2 /*return*/, result];
                    case 3:
                        e_1 = _a.sent();
                        this.setData('mandatoryFields', []);
                        // Commented due to https://jira.wixpress.com/browse/WCN-1878
                        // console.info('Error during fetching mandatory fields', e);
                        return [2 /*return*/, {
                                errorCode: 500,
                                translatedError: e_1.toString(),
                                status: 'FAILURE',
                            }];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.decorateWithUIProps = function (mandatoryFields) {
            return mandatoryFields
                .map(function (field) {
                // If we receive fieldName not 'state', but 'description.billingAddress.state'
                var lastPartOfFieldName = field.fieldName.split('.').pop();
                return MANDATORY_FIELDS_META[lastPartOfFieldName];
            })
                .filter(function (field) { return field; });
        };
        this.sortMandatoryFields = function (mandatoryFields) {
            mandatoryFields.sort(function (field1, field2) { return field2.priority - field1.priority; });
            return mandatoryFields;
        };
        this.setData = function (name, data) {
            _this.state[name] = data;
            _this.subscribers[name].forEach(function (listener) { return listener(data); });
        };
    }
    return Payments;
}());
exports.default = (new Payments());
//# sourceMappingURL=PaymentsStore.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-method-component/dist/src/data/PaymentsStore/PaymentsStore.js
// module id = 222
// module chunks = 0 1